import React, { Fragment } from "react";
import PropTypes from "prop-types";
import L from 'leaflet';
import { Marker, Tooltip } from 'react-leaflet';

const Markers = ({ markersToShow }) => {
    let markers = [];
    markersToShow.map((m, index) => {
        const marker = L.divIcon({
            className: `fa fa-${m.isStar ? 'star' : 'map-marker'} marker-` + m.size + ' marker-' + m.color
        });

        markers.push(<Marker position={[m.lat, m.long]} key={index} icon={marker} draggable={m.draggable} onDragend={(e) => m.onDragEnd(e, m.id)}>
            {m.tooltip ? <Tooltip>
                {m.tooltip}
            </Tooltip> : ''}
        </Marker>);
    });

    return markers;
};

Markers.propTypes = {
    markersToShow: PropTypes.array
};

export default Markers;